module.exports = __webpack_public_path__ + "media/images/front/about/point3_img04-69d87ec1b942021513d81a4d0e37ed5c.jpg";